<script lang="ts" setup>
import { useAdminSettings } from '~/composables/api/useAdminSettings'
const { getAll } = useAdminSettings()
await getAll()
</script>